import loadable from '@loadable/component';

export const ImoreSiteWrapper = loadable(
  () => import(/* webpackChunkName: "imore-site" */ './ImoreSiteWrapper'),
);
